import { render } from "./AdminEbayCategories.vue?vue&type=template&id=0c2b24da"
import script from "./AdminEbayCategories.vue?vue&type=script&lang=js"
export * from "./AdminEbayCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__